
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","viewBox":"0 0 18 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.9993 9.95004C17.9993 4.97984 13.9702 0.95072 9.00006 0.95072C4.02985 0.95072 0.000732422 4.97984 0.000732422 9.95004C0.000732422 14.4419 3.29165 18.1649 7.59388 18.84V12.5514H5.30892V9.95004H7.59388V7.96737C7.59388 5.71191 8.93743 4.46607 10.993 4.46607C11.9776 4.46607 13.0075 4.64184 13.0075 4.64184V6.85651H11.8728C10.7548 6.85651 10.4062 7.55022 10.4062 8.2619V9.95004H12.9021L12.5031 12.5514H10.4062V18.84C14.7085 18.1649 17.9993 14.4419 17.9993 9.95004Z","fill":"currentColor"}})])
          )
        }
      }
    